import { render, staticRenderFns } from "./AdminReview.vue?vue&type=template&id=5763795e"
import script from "./AdminReview.vue?vue&type=script&lang=js"
export * from "./AdminReview.vue?vue&type=script&lang=js"
import style0 from "./AdminReview.vue?vue&type=style&index=0&id=5763795e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports